import { logout } from "../api/AuthenticationAPI";
export const handleLogout = () => {
    logout();
};
